import React, { useEffect, useState } from 'react'
import moment from 'moment'
import Button from 'components/button/button'

import { openModal } from 'state/actions'

import { connect } from 'react-redux'

let updateInterval = null

const User = ({ wellnessData, openModal }) => {
    const [isVisible, setVisible] = useState(false)
    const [, forceUpdate] = useState()

    useEffect(() => {
        updateInterval = setInterval(() => {
            forceUpdate({})
        }, 60000)

        setTimeout(() => {
            setVisible(true)
        }, 1200)

        return () => {
            clearInterval(updateInterval)
        }
    }, [])

    const doWellnessModal = () => {
        openModal('wellness', 'wellness', wellnessData)
    }

    const getTimeToNextWellness = () => {
        const now = moment()
        const hour = now.format('H')

        let nextEventHour = null

        if (hour < 14) {
            nextEventHour = 14
        } else {
            nextEventHour = 24
        }

        const difference = now.clone().startOf('hour').add(nextEventHour - hour, 'hours').diff(now, 'minutes')

        const hours = Math.floor(difference / 60)
        const minutes = difference - (hours * 60)

        if (hours > 4) {
            return nextEventHour === 14 ? 'at 2pm today' : 'tomorrow morning'
        }

        let response = 'in '

        if (hours) {
            response += `${hours} hour${hours > 1 ? 's' : ''}`
        }

        if (minutes) {
            if (response) {
                response += ' '
            }

            response += `${minutes} minute${minutes > 1 ? 's' : ''}`
        }

        if (!response) {
            response = 'under a minute'
        }

        return response
    }

    if (!wellnessData || !wellnessData.quote) {
        return null
    }

    return (
        <div className="widget box dashboard-wellness">
            <div className={isVisible ? 'visible' : ''}>
                {wellnessData ?
                    <React.Fragment>
                        <h3>
                            Wellness
                            <span className="wellness-title-secondary">
                                {wellnessData.category}
                            </span>
                        </h3>
                        <div className="quote-container">
                            <div>
                                <h1>
                                    “{wellnessData.quote.copy}”
                                </h1>
                                <span>
                                    {wellnessData.quote.attribution}
                                </span>
                            </div>
                        </div>
                        <div className="button-container">
                            <Button
                                size={'big'}
                                level={'high'}
                                callback={doWellnessModal}
                                label={`${wellnessData.duration || '60'} seconds of ${wellnessData.button_verb}`}
                                icon={'check'}
                            />
                            <span>
                                We'll suggest something else {getTimeToNextWellness()}.
                            </span>
                        </div>
                    </React.Fragment>
                    :
                    null
                }
            </div>
        </div>
    )
}

export default connect(state => {
    return {
        wellnessData: state.auth.wellnessData
    }
}, {
    openModal,
})(User)